module.exports = __webpack_public_path__ + "img/galerie-6.c1f0cb6b.jpg";